import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FileUploadAwareJsonWriter1mx337tg0y9oj as FileUploadAwareJsonWriter } from '../json/internal/FileUploadAwareJsonWriter.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from '../json/BufferedSinkJsonWriter.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { urlEncoded5v8jd8by0u4 as urlEncode } from './internal/UrlEncode.mjs';
import { Key_getInstance4887rkxhu93r as Key_getInstance } from '../CustomScalarAdapters.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from '../json/MapJsonWriter.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  HttpHeader1d7ldebjomr00 as HttpHeader,
  HttpMethod_Post_getInstance1acsve6b42vet as HttpMethod_Post_getInstance,
  HttpMethod_Get_getInstance139ackgavp29i as HttpMethod_Get_getInstance,
  Builder2ocxamygt14i4 as Builder,
} from './Http.mjs';
import { Subscription2xxf73xmsvgi0 as Subscription } from '../Subscription.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { writeAny16i13331zbqlc as writeAny } from '../json/JsonWriters.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import {
  blackholeSink1e341pykjnhp5 as blackholeSink,
  buffer10rjf0ze3bqic as buffer,
} from '../../../../../../okio-parent-okio/okio/Okio.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buildGetUrl($this, serverUrl, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions) {
  return $this.p47(serverUrl, composeGetParams($this, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions));
}
function composePostParams($this, writer, operation, customScalarAdapters, query, extensionsWriter) {
  var uploads = {_v: null};
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  writer.o40();
  writer.q47('operationName');
  writer.a41(operation.operationName());
  writer.q47('variables');
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())(writer);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.o40();
  operation.o46(uploadAwareWriter, customScalarAdapters, false);
  uploadAwareWriter.p40();
  uploads._v = uploadAwareWriter.t47();
  if (!(query == null)) {
    writer.q47('query');
    writer.a41(query);
  }
  extensionsWriter(writer);
  writer.p40();
  return uploads._v;
}
function composePostParams_0($this, writer, operation, customScalarAdapters, sendApqExtensions, sendEnhancedClientAwarenessExtensions, query) {
  return composePostParams($this, writer, operation, customScalarAdapters, query, extensionsWriter($this, operation.operationId(), sendApqExtensions, sendEnhancedClientAwarenessExtensions));
}
function extensionsWriter($this, apqId, sendApqExtensions, sendEnhancedClientAwarenessExtensions) {
  if (!sendApqExtensions && !sendEnhancedClientAwarenessExtensions) {
    return DefaultHttpRequestComposer$Companion$extensionsWriter$lambda;
  }
  return (_this__u8e3s4) => {
    _this__u8e3s4.q47('extensions');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    _this__u8e3s4.o40();
    if (sendApqExtensions) {
      _this__u8e3s4.q47('persistedQuery');
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.o40();
      _this__u8e3s4.q47('version').c41(1);
      _this__u8e3s4.q47('sha256Hash').a41(apqId);
      _this__u8e3s4.p40();
    }
    if (sendEnhancedClientAwarenessExtensions) {
      _this__u8e3s4.q47('clientLibrary');
      // Inline function 'com.apollographql.apollo.api.json.writeObject' call
      _this__u8e3s4.o40();
      _this__u8e3s4.q47('name').a41('apollo-kotlin');
      _this__u8e3s4.q47('version').a41('4.4.2');
      _this__u8e3s4.p40();
    }
    _this__u8e3s4.p40();
    return Unit_instance;
  };
}
function composeGetParams($this, operation, customScalarAdapters, autoPersistQueries, sendDocument, sendEnhancedClientAwareness) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var queryParams = LinkedHashMap().bc();
  queryParams.x4('operationName', operation.operationName());
  // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
  var buffer = new (Buffer())();
  var $this$buildJsonString = new (BufferedSinkJsonWriter())(buffer, null);
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())($this$buildJsonString);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.o40();
  operation.o46(uploadAwareWriter, customScalarAdapters, false);
  uploadAwareWriter.p40();
  // Inline function 'kotlin.check' call
  if (!uploadAwareWriter.t47().n1()) {
    var message = 'FileUpload and Http GET are not supported at the same time';
    throw IllegalStateException().o(toString(message));
  }
  var variables = buffer.c3y();
  queryParams.x4('variables', variables);
  if (sendDocument) {
    queryParams.x4('query', operation.u47());
  }
  // Inline function 'com.apollographql.apollo.api.json.buildJsonString' call
  var buffer_0 = new (Buffer())();
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  var this_0 = new (BufferedSinkJsonWriter())(buffer_0, null);
  this_0.o40();
  if (autoPersistQueries) {
    this_0.q47('persistedQuery');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    this_0.o40();
    this_0.q47('version').c41(1);
    this_0.q47('sha256Hash').a41(operation.operationId());
    this_0.p40();
  }
  if (sendEnhancedClientAwareness) {
    this_0.q47('clientLibrary');
    // Inline function 'com.apollographql.apollo.api.json.writeObject' call
    this_0.o40();
    this_0.q47('name').a41('apollo-kotlin');
    this_0.q47('version').a41('4.4.2');
    this_0.p40();
  }
  this_0.p40();
  var extensions = buffer_0.c3y();
  // Inline function 'kotlin.text.isEmpty' call
  if (!(charSequenceLength(extensions) === 0)) {
    queryParams.x4('extensions', extensions);
  }
  return queryParams;
}
function DefaultHttpRequestComposer$Companion$extensionsWriter$lambda(_this__u8e3s4) {
  return Unit_instance;
}
var DefaultHttpRequestComposer$Companion$buildPostBody$1Class;
function DefaultHttpRequestComposer$Companion$buildPostBody$1() {
  if (DefaultHttpRequestComposer$Companion$buildPostBody$1Class === VOID) {
    class $ {
      constructor($operationByteString) {
        this.x47_1 = $operationByteString;
        this.v47_1 = 'application/json';
        this.w47_1 = fromInt($operationByteString.q2());
      }
      f47() {
        return this.v47_1;
      }
      g47() {
        return this.w47_1;
      }
      i47(bufferedSink) {
        bufferedSink.k3y(this.x47_1);
      }
    }
    initMetadataForClass($);
    DefaultHttpRequestComposer$Companion$buildPostBody$1Class = $;
  }
  return DefaultHttpRequestComposer$Companion$buildPostBody$1Class;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.j47_1 = 'X-APOLLO-OPERATION-ID';
        this.k47_1 = 'X-APOLLO-OPERATION-NAME';
        this.l47_1 = 'Apollo-Require-Preflight';
        this.m47_1 = 'Accept';
        this.n47_1 = 'multipart/mixed;deferSpec=20220824, application/graphql-response+json, application/json';
        this.o47_1 = 'multipart/mixed;subscriptionSpec=1.0, application/graphql-response+json, application/json';
      }
      p47(_this__u8e3s4, parameters) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        this_0.m1(_this__u8e3s4);
        var hasQuestionMark = contains(_this__u8e3s4, '?');
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = parameters.l3().p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          if (hasQuestionMark) {
            this_0.o1(_Char___init__impl__6a9atx(38));
          } else {
            hasQuestionMark = true;
            this_0.o1(_Char___init__impl__6a9atx(63));
          }
          this_0.m1(urlEncode(element.m3()));
          this_0.o1(_Char___init__impl__6a9atx(61));
          this_0.m1(urlEncode(element.n3()));
        }
        return this_0.toString();
      }
      y47(operation, customScalarAdapters, query, extensionsWriter) {
        var uploads = {_v: null};
        // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
        var buffer = new (Buffer())();
        var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
        uploads._v = composePostParams(Companion_instance, $this$buildJsonByteString, operation, customScalarAdapters, query, extensionsWriter);
        var operationByteString = buffer.y3x();
        var tmp;
        if (uploads._v.n1()) {
          tmp = new (DefaultHttpRequestComposer$Companion$buildPostBody$1())(operationByteString);
        } else {
          tmp = new (UploadsHttpBody())(uploads._v, operationByteString);
        }
        return tmp;
      }
      z47(apolloRequest) {
        var operation = apolloRequest.r42_1;
        var tmp0_elvis_lhs = apolloRequest.w42_1;
        var sendApqExtensions = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
        var sendEnhancedClientAwarenessExtensions = apolloRequest.d43_1;
        var tmp1_elvis_lhs = apolloRequest.x42_1;
        var sendDocument = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = apolloRequest.t42_1.a46(Key_getInstance());
        var customScalarAdapters = tmp2_elvis_lhs == null ? Key_getInstance().j45_1 : tmp2_elvis_lhs;
        var query = sendDocument ? operation.u47() : null;
        // Inline function 'com.apollographql.apollo.api.json.buildJsonMap' call
        var writer = new (MapJsonWriter())();
        composePostParams_0(Companion_instance, writer, operation, customScalarAdapters, sendApqExtensions, sendEnhancedClientAwarenessExtensions, query);
        var tmp = writer.r40();
        return (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DefaultHttpRequestComposerClass;
function DefaultHttpRequestComposer() {
  if (DefaultHttpRequestComposerClass === VOID) {
    class $ {
      constructor(serverUrl) {
        this.a48_1 = serverUrl;
      }
      b48(apolloRequest) {
        var operation = apolloRequest.r42_1;
        var tmp0_elvis_lhs = apolloRequest.t42_1.a46(Key_getInstance());
        var customScalarAdapters = tmp0_elvis_lhs == null ? Key_getInstance().j45_1 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.mutableListOf' call
        // Inline function 'kotlin.apply' call
        var this_0 = ArrayList().p2();
        var tmp = apolloRequest.r42_1;
        if (isInterface(tmp, Subscription())) {
          this_0.i2(new (HttpHeader())(Companion_instance.m47_1, Companion_instance.o47_1));
        } else {
          this_0.i2(new (HttpHeader())(Companion_instance.m47_1, Companion_instance.n47_1));
        }
        if (!(apolloRequest.v42_1 == null)) {
          this_0.u2(apolloRequest.v42_1);
        }
        var requestHeaders = this_0;
        var tmp1_elvis_lhs = apolloRequest.w42_1;
        var sendApqExtensions = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = apolloRequest.x42_1;
        var sendDocument = tmp2_elvis_lhs == null ? true : tmp2_elvis_lhs;
        var sendEnhancedClientAwarenessExtensions = apolloRequest.d43_1;
        var tmp3_elvis_lhs = apolloRequest.u42_1;
        var tmp_0;
        switch ((tmp3_elvis_lhs == null ? HttpMethod_Post_getInstance() : tmp3_elvis_lhs).w1_1) {
          case 0:
            tmp_0 = (new (Builder())(HttpMethod_Get_getInstance(), buildGetUrl(Companion_instance, this.a48_1, operation, customScalarAdapters, sendApqExtensions, sendDocument, sendEnhancedClientAwarenessExtensions))).h48(Companion_instance.l47_1, 'true');
            break;
          case 1:
            var query = sendDocument ? operation.u47() : null;
            var body = Companion_instance.y47(operation, customScalarAdapters, query, extensionsWriter(Companion_instance, operation.operationId(), sendApqExtensions, sendEnhancedClientAwarenessExtensions));
            // Inline function 'kotlin.let' call

            var it = (new (Builder())(HttpMethod_Post_getInstance(), this.a48_1)).i48(body);
            var tmp_1;
            if (startsWith(body.f47(), 'multipart/form-data')) {
              tmp_1 = it.h48(Companion_instance.l47_1, 'true');
            } else {
              tmp_1 = it;
            }

            tmp_0 = tmp_1;
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var httpRequestBuilder = tmp_0;
        return httpRequestBuilder.j48(requestHeaders).q43(apolloRequest.t42_1).y36();
      }
    }
    initMetadataForClass($, 'DefaultHttpRequestComposer');
    DefaultHttpRequestComposerClass = $;
  }
  return DefaultHttpRequestComposerClass;
}
function buildUploadMap($this, uploads) {
  // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
  var buffer = new (Buffer())();
  var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = uploads.l3();
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().h2(collectionSizeOrDefault(this_0, 10));
  var index = 0;
  var _iterator__ex2g4s = this_0.p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$4 = to(index_0.toString(), listOf(item.m3()));
    destination.i2(tmp$ret$4);
  }
  writeAny($this$buildJsonByteString, toMap(destination));
  return buffer.y3x();
}
function writeBoundaries($this, $receiver, writeUploadContents) {
  $receiver.m3y('--' + $this.m48_1 + '\r\n');
  $receiver.m3y('Content-Disposition: form-data; name="operations"\r\n');
  $receiver.m3y('Content-Type: application/json\r\n');
  $receiver.m3y('Content-Length: ' + $this.l48_1.q2() + '\r\n');
  $receiver.m3y('\r\n');
  $receiver.k3y($this.l48_1);
  var uploadsMap = buildUploadMap($this, $this.k48_1);
  $receiver.m3y('\r\n--' + $this.m48_1 + '\r\n');
  $receiver.m3y('Content-Disposition: form-data; name="map"\r\n');
  $receiver.m3y('Content-Type: application/json\r\n');
  $receiver.m3y('Content-Length: ' + uploadsMap.q2() + '\r\n');
  $receiver.m3y('\r\n');
  $receiver.k3y(uploadsMap);
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = $this.k48_1.w4().p1();
  while (_iterator__ex2g4s.q1()) {
    var item = _iterator__ex2g4s.r1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    $receiver.m3y('\r\n--' + $this.m48_1 + '\r\n');
    $receiver.m3y('Content-Disposition: form-data; name="' + index_0 + '"');
    if (!(item.h47() == null)) {
      $receiver.m3y('; filename="' + item.h47() + '"');
    }
    $receiver.m3y('\r\n');
    $receiver.m3y('Content-Type: ' + item.f47() + '\r\n');
    var contentLength = item.g47();
    if (!(contentLength === -1n)) {
      $receiver.m3y('Content-Length: ' + contentLength.toString() + '\r\n');
    }
    $receiver.m3y('\r\n');
    if (writeUploadContents) {
      item.i47($receiver);
    }
  }
  $receiver.m3y('\r\n--' + $this.m48_1 + '--\r\n');
}
function UploadsHttpBody$_get_contentLength_$ref_e5o4rd() {
  return (p0) => p0.g47();
}
var UploadsHttpBodyClass;
function UploadsHttpBody() {
  if (UploadsHttpBodyClass === VOID) {
    class $ {
      constructor(uploads, operationByteString) {
        this.k48_1 = uploads;
        this.l48_1 = operationByteString;
        this.m48_1 = uuid4().toString();
        this.n48_1 = 'multipart/form-data; boundary=' + this.m48_1;
        var tmp = this;
        tmp.o48_1 = lazy(() => {
          var countingSink = new (CountingSink())(blackholeSink());
          var bufferedCountingSink = buffer(countingSink);
          writeBoundaries(this, bufferedCountingSink, false);
          bufferedCountingSink.lc();
          var tmp = countingSink.q48_1;
          // Inline function 'kotlin.collections.sumOf' call
          var sum = 0n;
          var _iterator__ex2g4s = this.k48_1.w4().p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            var tmp_0 = sum;
            var tmp$ret$1 = element.g47();
            sum = add(tmp_0, tmp$ret$1);
          }
          var tmp$ret$0 = sum;
          var result = add(tmp, tmp$ret$0);
          return result;
        });
      }
      f47() {
        return this.n48_1;
      }
      g47() {
        var tmp0 = this.o48_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('contentLength', 1, tmp, UploadsHttpBody$_get_contentLength_$ref_e5o4rd(), null);
        return tmp0.n3();
      }
      i47(bufferedSink) {
        writeBoundaries(this, bufferedSink, true);
      }
    }
    initMetadataForClass($, 'UploadsHttpBody');
    UploadsHttpBodyClass = $;
  }
  return UploadsHttpBodyClass;
}
var CountingSinkClass;
function CountingSink() {
  if (CountingSinkClass === VOID) {
    class $ {
      constructor(delegate) {
        this.p48_1 = delegate;
        this.q48_1 = 0n;
      }
      u3u(source, byteCount) {
        this.p48_1.u3u(source, byteCount);
        this.q48_1 = add(this.q48_1, byteCount);
      }
      l6() {
        this.p48_1.l6();
      }
      lc() {
        this.p48_1.lc();
      }
    }
    initMetadataForClass($, 'CountingSink');
    CountingSinkClass = $;
  }
  return CountingSinkClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  DefaultHttpRequestComposer as DefaultHttpRequestComposer3cbqxfvy17yg2,
  Companion_instance as Companion_instancegdssxde1x86b,
};
//endregion

//# sourceMappingURL=DefaultHttpRequestComposer.mjs.map
